import React, { useState } from 'react'

const DatePickerWrapper = ({ question }) => {
  const [date, setDate] = useState(question.value ? question.value : '')
  const todaysDate = new Date().toISOString().split('T')[0]
  const dobQuestions = ['Xplor_ChildDOB', 'Xplor_PCDOB', 'Xplor_ACDOB']
  const maxDate = dobQuestions.includes(question.name) ? todaysDate : '2500-01-01'

  const handleChange = newDate => {
    question.value = newDate
    setDate(newDate)
  }

  return (
    <>
      {question.isReadOnly ? (
        <input disabled value={date} />
      ) : (
        <input type="date" value={date} onChange={e => handleChange(e.target.value)} max={maxDate} />
      )}
    </>
  )
}

export default DatePickerWrapper
